<template>

    <path v-if="props.tela.appCompatible==true" ref="svgRef" :d="props.tela.path" :title="tela.nombre" :transform-origin="transform_origin" :transform="transform" :style="style" :data-original="tela.transform" :data-nombre="tela.nombre"></path>
  
</template>

<script setup>
import { ref } from "vue";
const props = defineProps(["tela"]);
const tela=ref(props.tela)
const style=ref({})
const transform_origin=ref("")
const svgRef = ref(null);
const transform=ref(tela.value.rawTransform)


style.value["fill"]=props.tela.fill
if (props.tela.transparente != 1 ){

  style.value["stroke"]=props.tela.stroke
}
style.value["opacity"]=0





// Example usage

// const parts = splitString(props);

//console.log(getTransformString());


</script>

<style scoped>

path:hover{
  opacity: .5!important;
}

</style>